import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Dashboard",
  [CustomerMessages.applicationConcretingRequest]: "Concreting request",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Concreting request",
  [CustomerMessages.applicationContract]: "Contracts",
  [CustomerMessages.applicationConcreting]: "Concretings",
  [CustomerMessages.applicationInvoice]: "Invoices",
  [CustomerMessages.applicationConcretingApproval]: "Concreting approval",
  [CustomerMessages.applicationCertificate]: "Certificates",
  [CustomerMessages.applicationClient]: "Clients",
  [CustomerMessages.applicationPermission]: "Permissions",
  [CustomerMessages.applicationContractAmounts]: "Contract amounts",
  [CustomerMessages.applicationLogout]: "Logout",
  [CustomerMessages.applicationSettings]: "Settings",
  [CustomerMessages.applicationDocs]: "Documentation",
  [CustomerMessages.docsTabManual]: "Manual",
  [CustomerMessages.docsTabChangelog]: "What's new",
  [CustomerMessages.docsIndexTitle]: "Index",
  [CustomerMessages.docsVersionsTitle]: "Versions",
  [CustomerMessages.docsLoadError]: "Unable to load the documentation.",
  [CustomerMessages.docsNoVersions]: "No versions found.",
  [CustomerMessages.docsVersion]: "Version <VERSION>",
  [CustomerMessages.docsWhatChanged]: "What changed",
  [CustomerMessages.docsDetails]: "Details",
  [CustomerMessages.docsClose]: "Close",
  [CustomerMessages.docsCancel]: "Cancel",
  [CustomerMessages.docsKindAddedLabel]: "New",
  [CustomerMessages.docsKindAddedOne]: "new feature",
  [CustomerMessages.docsKindAddedMany]: "new features",
  [CustomerMessages.docsKindImprovedLabel]: "Improved",
  [CustomerMessages.docsKindImprovedOne]: "improvement",
  [CustomerMessages.docsKindImprovedMany]: "improvements",
  [CustomerMessages.docsKindFixedLabel]: "Fixed",
  [CustomerMessages.docsKindFixedOne]: "fix",
  [CustomerMessages.docsKindFixedMany]: "fixes",
  [CustomerMessages.docsKindBreakingLabel]: "Important",
  [CustomerMessages.docsKindBreakingOne]: "important change",
  [CustomerMessages.docsKindBreakingMany]: "important changes",
  [CustomerMessages.docsKindOtherLabel]: "Other",
  [CustomerMessages.docsKindOtherOne]: "item",
  [CustomerMessages.docsKindOtherMany]: "items",
  [CustomerMessages.docsVersionDetails]: "What's new in detail",
  [CustomerMessages.docsVersionRange]: "Summary of versions",
  [CustomerMessages.docsVersionNoDetails]: "Version <LINE> has no details yet",
  [CustomerMessages.docsVersionDetailsTitle]: "What's new in detail · Version <VERSION>",
  [CustomerMessages.docsVersionRangeTitle]: "Summary of versions · <FROM> → <TO>",
  [CustomerMessages.docsVersionRangeDialogTitle]: "Summary of versions",
  [CustomerMessages.docsVersionRangeHelp]:
    "Pick up to <MAX> version lines, such as 1.19.0 → 1.20.0. The summary joins highlights, improvements and fixes.",
  [CustomerMessages.docsVersionFrom]: "From",
  [CustomerMessages.docsVersionTo]: "To",
  [CustomerMessages.docsVersionRangeTooWide]: "The interval spans <COUNT> lines (<LINES>). Pick up to <MAX>.",
  [CustomerMessages.docsVersionOpenRange]: "Open summary",
  [CustomerMessages.docsVersionLine]: "Line <LINE>",
  [CustomerMessages.docsVersionFilter]: "Filter version",
  [CustomerMessages.docsVersionNoOptions]: "No version",
  [CustomerMessages.newVersionBanner]: "New version <VERSION>! See what's new.",
  [CustomerMessages.newVersionSee]: "See what's new",
  [CustomerMessages.newVersionDismiss]: "Mark as read",
  [CustomerMessages.newBadge]: "New",
  [CustomerMessages.allUsersStatusIconTitle]: "All users",
  [CustomerMessages.newUsersStatusIconTitle]: "New users",
  [CustomerMessages.activeUsersStatusIconTitle]: "Active users",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Inactivated users",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Blocked users",
  [CustomerMessages.inactivedUser]: "User inactivated",
  [CustomerMessages.activedUser]: "User activated",
  [CustomerMessages.errorInactivatingUser]: "Error when inactivating user",
  [CustomerMessages.errorActivatingUser]: "Error activating user",
  [CustomerMessages.inactivateUserTitle]: "Inactivate user",
  [CustomerMessages.activateUserTitle]: "Activate user",
  [CustomerMessages.inactivateUserText]: "Do you want to inactivate <USER_NAME> user?",
  [CustomerMessages.activateUserText]: "Do you want to activate <USER_NAME> user?",
  [CustomerMessages.inactivateUserButton]: "Inactivate",
  [CustomerMessages.activateUserButton]: "Activate"
};
